import { render, staticRenderFns } from "./ColonyTradeRow.vue?vue&type=template&id=5ad4ef1f"
import script from "./ColonyTradeRow.vue?vue&type=script&lang=ts"
export * from "./ColonyTradeRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports